/* global FLOWABLE */
/* global _ */
/* global angular */

import { transform } from "./MenuBar";

const _contextState = {
	$rootScopeContainer: null,
	modelId: null,
	appDefinition: null,
	renderPreviewCallback: null,
};

let _isAngularModuleConfigured = false;

export const angularRunContext = {
	isAngularModuleConfigured: () => _isAngularModuleConfigured,
	markAngularModuleAsConfigured: () => { _isAngularModuleConfigured = true; },
	getContext: () => _contextState,
	setContext: newContext => { Object.assign(_contextState, newContext); },
	clearContext: () => { _contextState.$rootScopeContainer = null; },
};

export const angularRunFunction = ($rootScope, $route, visTranslations, $http, eoVisCoreService, eoVisFormPreviewService) => {
	$http.get(FLOWABLE.CONFIG.contextRoot + "/vis-flowable-editor/static/i18n/translation.json", { cache: true })
		.then(translations => {
			visTranslations.setTranslations("en", translations.data);
		});

	const { $rootScopeContainer, modelId, appDefinition } = angularRunContext.getContext();
	
	// Patch Scope.prototype.$apply to be safe against nested $digest calls.
	// Flowable holds stale module-level $rootScope references. After the old app is
	// destroyed those stale refs have $$phase=null, so Flowable's guard passes and
	// $apply is called on a NEW scope that IS in $digest — throwing [$rootScope:inprog].
	//
	// Patching the PROTOTYPE (not just the $rootScope instance) covers both:
	//   - Regular child scopes: inherit via $rootScope in the prototype chain.
	//   - Isolate scopes: created with `new Scope()` and inherit Scope.prototype
	//     DIRECTLY, bypassing $rootScope entirely — the instance patch never fires.
	//
	// Each angular.bootstrap() creates a fresh Scope.prototype scoped to that injector,
	// so this patch is isolated to the current bootstrap and does not affect others.
	const _scopeProto = Object.getPrototypeOf($rootScope);
	if (_scopeProto && typeof _scopeProto.$apply === "function") {
		const _originalProtoApply = _scopeProto.$apply;
		_scopeProto.$apply = function safeApply (fn) {
			if (this.$root && this.$root.$$phase) {
				if (typeof fn === "function") {return fn();}
				if (typeof fn === "string") {return this.$eval(fn);}

				return undefined;
			}
			const result = _originalProtoApply.call(this, fn);
			// If this $apply ran on an OLD bootstrap's scope, queue a $digest on the
			// CURRENT live bootstrap's $rootScope so its DOM (e.g. the save button)
			// picks up model changes made through Flowable's stale scope references.
			// $evalAsync is safe: it schedules work without risking a nested-digest error.
			const { $rootScopeContainer } = angularRunContext.getContext();
			const liveRoot = $rootScopeContainer && $rootScopeContainer.$rootScope;
			if (liveRoot && liveRoot !== this.$root && !liveRoot.$$destroyed) {
				liveRoot.$evalAsync(angular.noop);
			}

			return result;
		};
	}

	$rootScopeContainer.$rootScope = $rootScope;
	$rootScopeContainer.eoVisFormPreviewService = eoVisFormPreviewService;
	$rootScope.model = {
		root: {
			globalId: modelId
		},
		globalId: modelId
	};
	$rootScope.currentAppDefinition = {
		id: appDefinition.id,
		name: appDefinition.name
	};
	$route.current = {
		params: {
			modelId: modelId
		}
	};
	let callbackListener = $rootScope.$on("$routeChangeStart", function (event, next, current) {
		// event.preventDefault();
		// // remove listener from sub element, otherwise it would trigger a dialog every time the user opens the preview without saving before
		// // we are running this the first time directly after the loading. Here the context is not dirty and the callback does nothing.
		const childScope = angular.element(document.getElementsByClassName("eo-vis-model-tabs-container")[0]).scope();
		childScope.$$listeners.$routeChangeStart = [];
	});

	eoVisCoreService.registerOnEvent("model.Loaded", () => {
		transformMenuBar(eoVisCoreService);
	});

	$rootScope.$on("$destroy", callbackListener);
};

angularRunFunction.$inject = [ "$rootScope", "$route", "visTranslations", "$http", "eoVisCoreService", "eoVisFormPreviewService" ];

/**
 * Wait until the model canvas is ready, then transform the menu bar
 */
function transformMenuBar (eoVisCoreService) {
	if (!eoVisCoreService.isModelCanvasReady(eoVisCoreService.getActiveModelId())) {
		setTimeout(() => {
			transformMenuBar(eoVisCoreService);
		}, 100);
	} else {
		transform();
	}
}
